import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, unref as _unref, withCtx as _withCtx } from "vue"


import SideMenuLink from "./SideMenuLink.vue";
import { enter, leave } from "./main-menu";


export default /*#__PURE__*/_defineComponent({
  __name: 'SideMenuComponent',
  props: {
  menu: Object,
  isRoot: Boolean,
  layout: String,
  position: String,
  menuIndex: Number,
},
  setup(__props) {

const props = __props



return (_ctx: any,_cache: any) => {
  const _component_SideMenuComponent = _resolveComponent("SideMenuComponent", true)!

  return (_openBlock(), _createElementBlock("li", null, [
    _createVNode(SideMenuLink, {
      class: _normalizeClass({
        // Animation
        [`opacity-0 translate-x-[50px] animate-[0.4s_ease-in-out_0.1s_intro-menu] animate-fill-mode-forwards animate-delay-${
          (__props.menuIndex + 1) * 10
        }`]: true,
        'side-menu--active':
          __props.isRoot && __props.menu.active && (__props.layout === 'enigma' || __props.layout === 'icewall'),
      }),
      menu: __props.menu,
      layout: __props.layout,
      isRoot: __props.isRoot,
      position: __props.position
    }, null, 8, ["class", "menu", "layout", "isRoot", "position"]),
    _createVNode(_Transition, {
      onEnter: _unref(enter),
      onLeave: _unref(leave)
    }, {
      default: _withCtx(() => [
        (__props.menu.subMenu?.length && __props.menu.activeDropdown)
          ? (_openBlock(), _createElementBlock("ul", {
              key: 0,
              class: _normalizeClass([
          {
            'rounded-lg bg-black/10 dark:bg-darkmode-900/30':
              __props.layout !== 'enigma',
            'rounded-lg bg-white/30 dark:bg-darkmode-900/30':
              __props.layout === 'enigma',
          },
        ])
            }, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.menu.subMenu, (menu, index) => {
                return (_openBlock(), _createBlock(_component_SideMenuComponent, {
                  key: index,
                  menuIndex: index,
                  menu: menu,
                  isRoot: false,
                  layout: __props.layout,
                  position: __props.position
                }, null, 8, ["menuIndex", "menu", "layout", "position"]))
              }), 128))
            ], 2))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["onEnter", "onLeave"])
  ]))
}
}

})